import { render, staticRenderFns } from "./ComprobanteDevengadoPage.vue?vue&type=template&id=16ea95de"
import script from "./ComprobanteDevengadoPage.js?vue&type=script&lang=js&external"
export * from "./ComprobanteDevengadoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports